import request from 'superagent';
import { message } from 'antd';
import { HEADER, CONTENT_TYPE_APP_JSON, API_URL, STORM_HOST } from './constants';
import { strings } from '../../localization';
import keycloak from '../keycloak';
import { AFTER_LOGOUT_REDIRECT } from '../index';
import { parse } from 'qs';
/**
 * Makes an REST api call to defined action using defined method (GET, POST, ...)
 * with defined options (data, headers, queryParams)
 *
 * During loading a application wide loader is dispatched.
 *
 * @param url - string for a define endpoint
 * @param method - string defining HTTP method, see /src/javascript/constants/apiRoutes
 * @param headers - json object defining "data" for POST, PUT, PATCH, DELETE methods, "headers" and, "queryParams"
 * @param data - json object defining "data" for POST, PUT, PATCH, DELETE methods, "headers" and, "queryParams"
 * @returns {Promise.<T>}
 */
const req = (url, method, headers, data, textResponse) =>
    new Promise((resolve, reject) => {
        // console.log('headers', headers);
        // console.log(resolve);
        keycloak
            .updateToken()
            .success(refreshed => {
                if (refreshed) {
                    keycloak.setTokenStorage();
                }

                const { token } = keycloak.getTokenStorage();

                // console.log(request[method.toLowerCase()]);
                request[method.toLowerCase()](url)
                    .set({ ...headers, [HEADER.X_AUTH_TOKEN]: token || undefined })
                    .set('Accept', textResponse ? 'text/plain' : 'application/json')
                    .send(data)
                    .then(res => resolve(res))
                    .catch(error => 
                    {
                        reject(error);
                    });
                    // .end((err, res) => {
                    //    // console.log(res,err);
                    //    resolve({ res, err });
                    // });
            })
            .error(() => {
                keycloak.removeTokenStorage();
                keycloak.logout({
                    redirectUri: AFTER_LOGOUT_REDIRECT
                });
            });
    });

const getAuthTokenFromPath = () => {
    const path = parse(window.location.search, { ignoreQueryPrefix: true });

    return path.authToken;
}

const reqMobile = (url, method, headers, data, textResponse) =>
    new Promise((resolve, reject) => {

        const { token } = keycloak.getTokenStorage();

        // console.log(request[method.toLowerCase()]);
        request[method.toLowerCase()](url)
            .set({ ...headers, [HEADER.X_AUTH_TOKEN]: token || undefined })
            .set('Accept', textResponse ? 'text/plain' : 'application/json')
            .send(data)
            .then(res => resolve(res))
            .catch(error => 
            {
                reject(error);
            });
            // .end((err, res) => {
            //    // console.log(res,err);
            //    resolve({ res, err });
            // });
                    
    });

const api = (route, method, data, optionsHeaders = {}, storm = false, textResponse = false) =>
    new Promise((resolve, reject) => {
        const tokens = keycloak.getTokenStorage();

        if (!(tokens && tokens.token)) {
            return;
        }

        const url = `${storm ? STORM_HOST : API_URL}${route}`;
        console.log('Calling api call: ', url);

        const headers = {
            [HEADER.CONTENT_TYPE]: CONTENT_TYPE_APP_JSON,
            [HEADER.ACCEPT]: CONTENT_TYPE_APP_JSON,
            ...optionsHeaders
        };

        const hasAuthToken = getAuthTokenFromPath() !== undefined && getAuthTokenFromPath() !== null;

        const requestMethod = hasAuthToken ? reqMobile : req;

        return requestMethod(url, method, headers, data, textResponse).then(res => {
            // console.log(res);

            // Manually handled timout status
            if (!res) {
                reject(new Error(strings.msgErrorApi));
                return;
            }

            if (res.status === 401) {
                keycloak.removeTokenStorage();
                // keycloak.logout({
                //     redirectUri: AFTER_LOGOUT_REDIRECT
                // });
                window.location = AFTER_LOGOUT_REDIRECT;
            }

            if (res.status >= 300) {
                const errorMessage = res.body.message
                    ? res.body.message
                    : res.body.errorMessage
                    ? res.body.errorMessage
                    : '';

                message.error(`${strings.msgErrorApi}: ${errorMessage}`);

                reject(errorMessage || strings.msgErrorApi);
                return;
            }
            resolve(res);
        }).catch(error => {
            reject(error);
        });
    });

export { api };
